import React from 'react';

import peter from '../../images/Peter-Laurentius.png';


export default class extends React.Component {

  render() {

    let h2Margin = "1em 0 4.3em";
    if(this.props.h3) h2Margin = "1em 0 1em";

    return (
      <div className="full-responsive black">
        <div className="wrap">
          <div className="col-9" style={{padding:"3%"}}>
            <h2 className="logo-text" style={{ marginBottom: ".3em" }}>Strategische Berichten & Positionering <span style={{ opacity: ".7" }}>voor Tech Founders</span></h2>
            {this.props.h1 && (<h1 className="header-responsive" style={{fontFamily: "Times New Roman, Times, serif", marginTop: "0", marginBottom: ".3em"}}>{this.props.h1}</h1>)}
            {this.props.h1split1 && this.props.h1split2 && (<h1 className="header-responsive" style={{fontFamily: "Times New Roman, Times, serif", marginTop: "0", marginBottom: ".3em"}}>{this.props.h1split1}<span style={{color: "#E5C88D", fontStyle:"italic"}}>{this.props.h1split2}</span></h1>)}
            <h2 style={{fontSize:"1.1em", opacity:".7", margin:h2Margin}}>{this.props.h2}</h2>
            {this.props.h3 && <h3 style={{fontSize:"1.1em", opacity:".7", margin:"1em 0 4.3em"}}>{this.props.h3}</h3>}
          </div>
          <div className="col-3 md-shown-inline" style={{marginTop:"4em"}}>
            <div style={{position:"relative"}}>
              <img src={peter} alt="Ghostin.nl LinkedIn Ghostwriter Autoriteit Bouwer | Welkom!" style={{width:"530px", maxWidth:"70%", borderRadius:"50%", background:"#fff"}} />
            </div>
          </div>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/components/Hero.js